import { Controller } from "@hotwired/stimulus"

// Passo di pages/VerificaBandi.js: «Apri/Chiudi» di un passo della scheda di verifica. La partenza è aperta in
// «Completa» o se il passo non è confermato (in «Semplice» un passo confermato parte chiuso). Come lo stato di React
// dopo load(), l'apertura scelta resta quando la scheda è riletta con morph (risposta di un'azione o refresh dallo
// stream del bando); se cambia la partenza (passo confermato adesso, modalità cambiata) si torna alla partenza, come
// useEffect(() => setOpen(partenza), [partenza]).
export default class extends Controller {
  static targets = ["testa", "pulsante", "contenuto"]
  static values = { ok: Boolean, semplice: Boolean }

  connect() {
    this.partenzaCorrente = this.partenza()
    this.open = this.element.dataset.aperto === "si"
  }

  partenza() {
    return !this.sempliceValue || !this.okValue
  }

  toggle() {
    this.mostra(!this.open)
  }

  // turbo:morph-element: il server ha riscritto il passo con la sua partenza
  riletto(event) {
    if (event.target !== this.element) return
    const p = this.partenza()
    if (p !== this.partenzaCorrente) {
      this.partenzaCorrente = p
      this.mostra(p)
    } else {
      this.mostra(this.open)
    }
  }

  modalita(event) {
    this.sempliceValue = (event.detail?.modalita || document.body.dataset.modalita) === "semplice"
    const p = this.partenza()
    if (p === this.partenzaCorrente) return
    this.partenzaCorrente = p
    this.mostra(p)
  }

  // vai_al_passo_controller: apre il passo se è chiuso
  apri() {
    if (!this.open) this.mostra(true)
  }

  mostra(open) {
    this.open = open
    this.element.dataset.aperto = open ? "si" : "no"
    this.testaTarget.classList.toggle("mb-3", open)
    this.pulsanteTarget.setAttribute("aria-expanded", String(open))
    this.pulsanteTarget.textContent = open ? "Chiudi" : "Apri"
    this.contenutoTarget.hidden = !open
  }
}
